export function formatLocalDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatDisplayDate(isoDate) {
  if (!isoDate) return "";
  const match = String(isoDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return "";
  return `${match[3]}-${match[2]}-${match[1]}`;
}

export function calendarMonthRange(offset = 0, refDate = new Date()) {
  const y = refDate.getFullYear();
  const m = refDate.getMonth() + offset;
  return {
    fromDate: formatLocalDate(new Date(y, m, 1)),
    toDate: formatLocalDate(new Date(y, m + 1, 0))
  };
}

export function indianFinancialYearRange(period = "current", refDate = new Date()) {
  const y = refDate.getFullYear();
  const month = refDate.getMonth();
  let fyStartYear = month >= 3 ? y : y - 1;
  if (period === "prev") fyStartYear -= 1;
  return {
    fromDate: `${fyStartYear}-04-01`,
    toDate: `${fyStartYear + 1}-03-31`
  };
}

export function dateRangeForPreset(type, refDate = new Date()) {
  const today = refDate;
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());

  switch (type) {
    case "currentFY":
      return indianFinancialYearRange("current", today);
    case "prevFY":
      return indianFinancialYearRange("prev", today);
    case "today":
      return { fromDate: formatLocalDate(today), toDate: formatLocalDate(today) };
    case "yesterday":
      return {
        fromDate: formatLocalDate(yesterday),
        toDate: formatLocalDate(yesterday)
      };
    case "thisWeek":
      return { fromDate: formatLocalDate(startOfWeek), toDate: formatLocalDate(today) };
    case "thisMonth":
      return calendarMonthRange(0, today);
    case "lastMonth":
      return calendarMonthRange(-1, today);
    default:
      return null;
  }
}

export function matchingDatePreset(fromDate, toDate, refDate = new Date()) {
  if (!fromDate || !toDate) return null;

  const cur = indianFinancialYearRange("current", refDate);
  if (fromDate === cur.fromDate && toDate === cur.toDate) return "currentFY";

  const prev = indianFinancialYearRange("prev", refDate);
  if (fromDate === prev.fromDate && toDate === prev.toDate) return "prevFY";

  const todayStr = formatLocalDate(refDate);
  if (fromDate === todayStr && toDate === todayStr) return "today";

  const yesterday = new Date(refDate);
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = formatLocalDate(yesterday);
  if (fromDate === yesterdayStr && toDate === yesterdayStr) return "yesterday";

  const startOfWeek = new Date(refDate);
  startOfWeek.setDate(refDate.getDate() - refDate.getDay());
  if (fromDate === formatLocalDate(startOfWeek) && toDate === todayStr) return "thisWeek";

  const thisMonth = calendarMonthRange(0, refDate);
  if (fromDate === thisMonth.fromDate && toDate === thisMonth.toDate) return "thisMonth";

  const lastMonth = calendarMonthRange(-1, refDate);
  if (fromDate === lastMonth.fromDate && toDate === lastMonth.toDate) return "lastMonth";

  return null;
}
